import { useRecoilState, useRecoilValue } from "recoil";
import {
  resetSubmoduleDataState,
  showScriptsSubmoduleState,
  submoduleDatas,
} from "../atoms/atom";
import { useEffect, useState } from "react";
import CloseIconButton from "../../../../components/CloseIconButton";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import EditButton from "../../../../components/EditButton";
import { FolderIcon } from "@heroicons/react/24/solid";
import ReactTooltip from "react-tooltip";
import { getScriptContent } from "../../../../actions/Utilities/ScriptConfiguration";
import { SciptForm } from "../forms/SciptForm";
import { toast } from "../../../../components/toastNotification";
import TableFilters from "../TableFilters";
import useGetFolderPath from "../hooks/useGetFolderPath";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";

export const SubModuleScriptTable = ({ refetchScript }) => {
  const [tableData, setTableData] = useState([]);
  const [isShow, setIsShow] = useRecoilState(showScriptsSubmoduleState);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [submoduleData, setSubmoduleData] = useRecoilState(submoduleDatas);
  const [scriptContent, setScriptContent] = useState(undefined);
  const [rowForEdit, setRowForEdit] = useState(undefined);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState();

  const { data: currentDirectory } = useGetFolderPath();
  //Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const editPermission =
    PERMISSIONS.permission_utilities_scriptconfiguration_edit;
  const onClose = () => {
    setIsShow(false);
  };

  const copyPath = async (path) => {
    await navigator.clipboard.writeText(path);
    toast.fire("Success", `Folder path copied successfully`, "success");
  };

  const retrieveScriptContent = async (state, rowData) => {
    const fileName = rowData.path;
    try {
      getScriptContent(fileName).then((content) => {
        if (content === "File not exist") {
          toast.fire(
            "Warning",
            `${content}. Please check path folder.`,
            "warning"
          );
        } else {
          if (state === "edit") {
            setScriptContent(content);
            setRowForEdit(rowData);
            setIsEdit(true);
          } else {
            setScriptContent(content);
            setRowForEdit(rowData);
            setIsView(true);
          }
        }
      });
    } catch (error) {}
  };

  const matColumns = [
    {
      title: "Function Name",
      render: (rowData) => {
        return (
          <span
            className="blueAndBold underline cursor-pointer"
            onClick={() => {
              retrieveScriptContent("view", rowData);
            }}
          >
            {rowData.functionName}
          </span>
        );
      },
    },
    {
      title: "Description",
      field: "description",
      align: "left",
    },
    {
      title: "Created by",
      field: "createdBy",
      align: "left",
    },
    {
      title: "Modified by",
      align: "left",
      render: (rowdata) => {
        return (
          <div>{rowdata.modifiedBy ? rowdata.modifiedBy : "unspecified"}</div>
        );
      },
    },
    {
      title: "Modified date",
      align: "left",
      render: (rowdata) => {
        return (
          <div>
            {rowdata.modifiedDate
              ? new Date(rowdata.modifiedDate).toLocaleDateString()
              : "unspecified"}
          </div>
        );
      },
    },
    {
      title: "Folder Path",
      align: "center",
      render: (rowData) => {
        return (
          <div className="grid grid-col-1 items-center place-content-center mr-6 ">
            <FolderIcon
              data-tip={rowData.path}
              data-for="path"
              className="text-white bg-primary rounded-full h-7 w-7 p-1"
              onClick={() => {
                copyPath(currentDirectory + rowData.path);
              }}
            />
            <ReactTooltip
              id="path"
              place="top"
              effect="solid"
              type="info"
              className="daTooltip"
              border={true}
              arrowColor="#0078d7"
              borderColor="#0078d7"
              backgroundColor="bg-blue-600"
              textColor="#0078d7"
            />
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return (
          userPermissions.includes(editPermission) && (
            <div className="grid grid-col-1 justify-items-center mr-5">
              <EditButton
                onClick={() => {
                  retrieveScriptContent("edit", rowData);
                }}
              />
            </div>
          )
        );
      },
    },
  ];

  //mapping tabledata needed to be extensible
  useEffect(() => {
    const sortedData = submoduleData.map((module) => ({ ...module }));
    if (sortedData) {
      setTableData(sortedData);
    }
    const sortedItems = filteredItems.map((item) => ({ ...item }));
    if (filteredItems) {
      setFilteredData(sortedItems);
    }
  }, [filterText, setIsEdit]);

  //Filters
  const filteredItems = submoduleData?.filter((item) =>
    item.functionName?.toLowerCase()?.includes(filterText?.toLowerCase())
  );

  return (
    <>
      {!isEdit && !isView && (
        <div className="mt-4 rounded-md pb-4">
          <div className="flex flex-row item-center space-x-4">
            <TableFilters
              setIsSearching={false}
              setFilterText={setFilterText}
              moduleDetails="Function Name"
              textInputName="funtionName"
              disabledButton={false}
            />
          </div>
        </div>
      )}
      <div className="rounded bg-white space-y-3 px-4 py-2 border-solid border-2 border-black-600">
        {isEdit || isView ? (
          <>
            <SciptForm
              setIsEdit={setIsEdit}
              scriptContent={scriptContent}
              rowForEdit={rowForEdit}
              refetchScript={refetchScript}
              setIsView={setIsView}
              isView={isView}
            />
          </>
        ) : (
          <>
            {" "}
            <div className="relative -mt-4 -mr-5">
              <CloseIconButton onClick={() => onClose()} />
            </div>
            <div className="pt-4 pb-2">
              <MaterialExTable
                columns={matColumns}
                data={filterText ? filteredData : tableData}
                isLoading={false}
                selection={false}
                setOpenModal={false}
                isDeactivate={false}
                selectableRowDisabled={false}
                paging={false}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
